var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: "Crear Descarga de Información" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos, "estado-id": _vm.estadoId },
            on: { guardar: _vm.handleGuardarClick },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.informacionGeneral } },
                [
                  _c("DescargaActividadForm", {
                    attrs: { "test-id": "CrearDescargaActividadModal" },
                    on: { change: _vm.handleInformacionGeneralChange }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarVehiculos } },
                [
                  _c("AsociarFlotaEtiquetaVehiculoIndividual", {
                    attrs: { "col-def-vehiculo": _vm.vehiculoColDefs },
                    on: { change: _vm.handleAsociacionesChange }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarActividades } },
                [
                  _c(
                    "PasoAsociacion",
                    [
                      _c("AsociarTiposActividad", {
                        model: {
                          value: _vm.idsTipoActividad,
                          callback: function($$v) {
                            _vm.idsTipoActividad = $$v
                          },
                          expression: "idsTipoActividad"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarDispositivos } },
                [
                  _c(
                    "PasoAsociacion",
                    [
                      _c("AsociarDispositivos", {
                        model: {
                          value: _vm.idsDispositivo,
                          callback: function($$v) {
                            _vm.idsDispositivo = $$v
                          },
                          expression: "idsDispositivo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.seleccionarCampos } },
                [
                  _c("AsociarCampos", {
                    model: {
                      value: _vm.idsCampo,
                      callback: function($$v) {
                        _vm.idsCampo = $$v
                      },
                      expression: "idsCampo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Descarga de Información"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleConfirmacionGuardar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.permiteContinuarConfirm,
          titulo: _vm.tituloPermiteContinuar,
          mensaje: _vm.mensajePermiteContinuar,
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.permiteContinuarConfirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }